import {loadBlockLazyImages, loadElementLazyImage} from "../helpers/lazy-load";
//import {smoothScrollCreate, smoothScrollKill} from "../scroll-smoother";
import { gsap, Power2 } from 'gsap'


let windowHeight = window.innerHeight

$('.js-open-popup').click(function(){
  windowHeight = window.outerHeight
  let popup_name = $(this).data('popup')
  let popup = $('.js-popup[data-popup="'+ popup_name +'"]')

  openPopup(popup)
})


$(document).on('click', '.js-close-popup', function(){
  closePopup($(this))
})

$(document).keyup(function(e) {
  if (e.key === "Escape") { // escape key maps to keycode `27`
    closePopup($('.js-popup'))
  }
});




export function openPopup(popup){
  console.log(popup)
  console.log('opem popup')
  if (popup.length){
    popup.show()
    gsap.to(popup, {duration: 1, top: 0, ease: 'power2'});

    // load lazy data
    loadBlockLazyImages(popup)


    // if video popup play video
    if (popup.hasClass('video-popup')){
      gsap.to(popup.find('video'), {duration: 1, top: 0, delay: 0.5, ease: 'power2'});

      let video = popup.find('video')
      if (video.length){
        video[0].play()
        video[0].volume = 1
      }
    }


    $('html').addClass('modal-open')

    //smoothScrollKill()
  }
}

export function closePopup(el){
  let popup = el.closest('.js-popup')
  let video = popup.find('video')

  if (video.length) {
    video[0].pause()
  }

  gsap.to(popup, {duration: 1, top: "100vh", ease: 'power2', onComplete: ()=> {
    popup.hide()
    gsap.set(popup.find('video'), {top: '30vh'});

    $('html').removeClass('modal-open')
    //smoothScrollCreate()
  }
  });
  
}
